import React from "react";

const Footer = () => {
  return (
    <div className="footer_wrap">
      <div className="footer_back">
        <div className="footer_top">
          <div className="footer_box left">
            <div className="footer_logo_box">
              <div className="footer_logo"></div>
            </div>
            <div className="footer_text_box">
              키움성장의원｜서울특별시 서초구 반포대로 287 래미안퍼스티지
              중심상가 3층 <br />
              사업자번호 : 209-91-56996 <br />
              대표자명 : 허 경｜TEL: 02-532-8575
            </div>
          </div>
          <div className="footer_box right">
            <div
              className="footer_icon youtube"
              onClick={() =>
                window.open("https://youtube.com/@Kiumtv?si=DxftFuul2W62hO8G")
              }
            ></div>
            <div
              className="footer_icon kakao"
              onClick={() => window.open("http://pf.kakao.com/_xnRukb")}
            ></div>
            <div
              className="footer_icon blog"
              onClick={() => window.open("https://blog.naver.com/h_kyoung")}
            ></div>
          </div>
        </div>
        <div className="footer_bottom">
          <div className="footer_bottom_text">
            ⓒ Copyright “Growth Clinic”. All Rights Reserved
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
